import { CommonButton } from '@Components/common/Button';
import Link from '@Components/common/Link';
import PhoneInput from 'react-phone-number-input';
import styled, { css } from 'styled-components';
import { mq, rgba } from 'stylesheets/utils';

export const AuthView = styled.div`
  display: flex;
  align-items: flex-end;
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 100vh;
  padding-left: 110px;
  margin-top: -80px;
  ${mq(768)} {
    padding-left: 0;
    margin-top: -60px;
    align-items: center;
  }
`;

export const CenteredAuthView = styled(AuthView)`
  align-items: center;
  padding: 60px 0;
`;

export const AuthImage = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  max-width: 82.2rem;
  height: 100%;
  background-image: url('/auth_img.png');
  background-repeat: no-repeat;
  background-size: cover;
  transform: scale(-1, 1) /* rtl: none */;
  z-index: -1;
  ${mq(768)} {
    display: none;
  }
`;

export const AuthForm = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 400px;
  width: 100%;
  margin: 58px 115px 0 auto;
  ${mq(768)} {
    margin: 0 auto;
  }
`;

export const CenteredAuthForm = styled(AuthForm)`
  margin: 0 auto;
`;

export const Title = styled.h4`
  font-size: ${({ theme }) => theme.fontsizes.h4};
  font-weight: ${({ theme }) => theme.fontWeight.font400};
  color: ${({ theme }) => theme.colors.black};
  margin: 10px 0 0 0;
`;

export const SubTitle = styled.p`
  font-size: ${({ theme }) => theme.fontsizes.body16};
  font-weight: ${({ theme }) => theme.fontWeight.font400};
  color: ${({ theme }) => theme.colors.black};
  margin-bottom: 24px;
  text-align: center;
`;

/* background-color: ${(props) => (props.value.length ? 'red' : 'palevioletred')}; */
export const InputIcon = styled.div`
  position: absolute;
  top: 16px;
  right: 20px;
  transition: 0.3s ease all;
`;

const inputStyle = css`
  padding: 16px 20px;
  font-size: ${({ theme }) => theme.fontsizes.body16};
  background-color: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.black2};
  font-weight: ${({ theme }) => theme.fontWeight.font400};
  max-width: 400px;
  max-height: 50px;
  min-height: 48px;
  height: 100%;
  overflow: hidden;
  border-radius: 0.4rem;
  width: 100%;
  border: none;
  transition: 0.3s ease all;
  display: inline-block;
  border: 1px solid ${({ theme }) => theme.colors.lightenBlue};

  &:placeholder-shown {
    background-color: ${({ theme }) => theme.colors.lightenBlue};
    ${InputIcon} {
      opacity: 0;
    }
  }
  &::placeholder {
    color: ${({ theme }) => theme.colors.lightPurple};
    font-size: ${({ theme }) => theme.fontsizes.body14};
  }
  &:focus {
    background-color: ${({ theme }) => theme.colors.white};
  }
`;

export const Input = styled.input<{ readonly hasIcon?: boolean }>`
  ${inputStyle};
  ${({ hasIcon }) =>
    hasIcon &&
    css`
      padding-right: 60px;
    `}
`;

export const StyledPhoneInput = styled(PhoneInput)`
  position: relative;
  input {
    ${inputStyle}
    padding-left: 75px;
    padding-right: 60px;
  }
  .PhoneInputCountry {
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
    margin-right: 0;
    .PhoneInputCountrySelectArrow {
      display: none;
    }
    .PhoneInputCountryIcon--border {
      box-shadow: none;
      border-radius: 4px;
      overflow: hidden;
    }
  }
`;

export const ErrorMessage = styled.p`
  font-size: ${({ theme }) => theme.fontsizes.body12};
  color: ${({ theme }) => theme.colors.brandColor};
  font-weight: ${({ theme }) => theme.fontWeight.font400};
  margin-top: 0.4rem;
  padding: 0 10px;
`;

export const FieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 1rem;
  max-width: 400px;
  width: 100%;
  position: relative;
  border-radius: 0.4rem;
  &:last-of-type {
    margin-bottom: 6rem;
    ${Input} {
    }
  }
`;

export const FieldWrapperWithError = styled(FieldWrapper)`
  margin-bottom: 50px;
  ${ErrorMessage} {
    position: absolute;
    left: 0;
    bottom: 0;
    margin: 0;
    transform: translateY(110%);
  }
`;

export const SignUpButton = styled(CommonButton)`
  width: 100%;
  min-height: 50px;
  text-align: center;
  margin-bottom: 14px;
  margin-top: 0;
`;

export const Remember = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  width: 100%;
  padding-bottom: 60px;
  margin-bottom: 40px;
  position: relative;
  &::after {
    position: absolute;
    content: '';
    left: 50%;
    transform: translateX(-50%);
    bottom: 0;
    width: 590px;
    height: 1px;
    background-color: ${({ theme }) => theme.colors.lightPurple};
    opacity: 0.5;
  }
  ${mq(768)} {
    &::after {
      width: 100%;
    }
  }
`;

export const AcceptConditions = styled.div`
  width: 100%;
  padding-bottom: 0;
  margin-top: 52px;
  margin-bottom: 20px;
  ${mq(576)} {
    justify-content: space-evenly;
    flex-wrap: wrap;
    margin-top: 2rem;
    & > * {
      margin-right: 0;
      margin-bottom: 12px;
    }
  }
`;

export const CheckBox = styled.div`
  min-width: 24px;
  max-width: 24px;
  min-height: 24px;
  max-height: 24px;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.lightenBlue};
  margin-right: 12px;
  transition: 0.3s ease all;
  position: relative;
  cursor: pointer;
  margin-top: 2px;
  &::after {
    position: absolute;
    content: '';
    background-color: ${({ theme }) => theme.colors.brandColor};
    width: 16px;
    height: 16px;
    border-radius: 4px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    opacity: 0;
    transition: 0.2s ease opacity;
  }
`;

export const CheckField = styled.label`
  display: flex;
  position: relative;
  font-size: ${({ theme }) => theme.fontsizes.body14};
  font-weight: ${({ theme }) => theme.fontWeight.font400};
  color: ${({ theme }) => theme.colors.black2};
  cursor: pointer;
  &:hover {
    ${CheckBox} {
      border-color: ${({ theme }) => theme.colors.brandColor};
    }
  }
  input[type='checkbox'] {
    opacity: 0;
    position: absolute;
    &:checked {
      & + ${CheckBox} {
        border-color: ${({ theme }) => theme.colors.brandColor};
        &::after {
          opacity: 1;
        }
      }
    }
  }
`;

export const UnderLineLink = styled(Link)`
  font-size: ${({ theme }) => theme.fontsizes.body12};
  font-weight: ${({ theme }) => theme.fontWeight.font400};
  color: ${({ theme }) => theme.colors.black2};
  position: relative;
  white-space: nowrap;
  &::after {
    position: absolute;
    content: '';
    bottom: 0;
    left: 0;
    width: 100%;
    height: 1px;
    background-color: ${({ theme }) => theme.colors.black2};
  }
`;

export const AuthFormFooter = styled.div`
  margin-bottom: 5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  p {
    font-size: ${({ theme }) => theme.fontsizes.body16};
    font-weight: ${({ theme }) => theme.fontWeight.font400};
    color: ${({ theme }) => theme.colors.black2};
  }
`;

export const Signup = styled(Link)`
  font-size: ${({ theme }) => theme.fontsizes.body16};
  font-weight: ${({ theme }) => theme.fontWeight.font400};
  color: ${({ theme }) => theme.colors.auth.blue};
`;
export const BackLogin = styled(Signup)`
  margin-top: 20px;
`;
export const RegisterFormFooter = styled(AuthFormFooter)`
  margin-top: 1rem;
  margin-bottom: 7rem;
`;

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 1;
  background-color: ${({ theme }) => rgba(theme.colors.black2, 0.7)};
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const AuthDialog = styled.div`
  width: 46.5rem;
  height: 35.5rem;
  background-color: ${({ theme }) => theme.colors.white};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 6rem 2rem 4rem 2rem;
  border: 1px solid ${({ theme }) => theme.colors.auth.lightPurple};
  border-radius: 4px;
`;

export const TitleDialog = styled.h5`
  font-size: ${({ theme }) => theme.fontsizes.h5};
  font-weight: ${({ theme }) => theme.fontWeight.font700};
  color: ${({ theme }) => theme.colors.black2};
  margin: 1.6rem 0;
`;

export const MessageDialog = styled.p`
  font-size: ${({ theme }) => theme.fontsizes.body16};
  font-weight: ${({ theme }) => theme.fontWeight.font400};
  color: ${({ theme }) => theme.colors.gray};
  margin-bottom: 38px;
  text-align: center;
  max-width: 350px;
`;

export const ButtonDialog = styled(Link)`
  background-color: ${({ theme }) => theme.colors.brandColor};
  color: ${({ theme }) => theme.colors.white};
  text-align: center;
  border: none;
  border-radius: 4px;
  height: 4.8rem;
  line-height: 48px;
  width: 12rem;
  margin: 0;
`;

export const ResetTitle = styled(TitleDialog)`
  margin: 24px 0 14px 0;
`;
export const CountryCode = styled.span`
  z-index: 1;
  color: ${({ theme }) => theme.colors.lightPurple};
  font-size: 1.6rem;
  line-height: 1;
  position: absolute;
  top: 19px;
  left: 16px;
  border-right: 1px solid ${({ theme }) => theme.colors.black};
  padding-right: 12px;
`;
export const CheckBoxContent = styled.div`
  line-height: 24px;
`;
